import { render, staticRenderFns } from "./FacilityLimits.vue?vue&type=template&id=cd654e3c&scoped=true"
import script from "./FacilityLimits.vue?vue&type=script&lang=js"
export * from "./FacilityLimits.vue?vue&type=script&lang=js"
import style0 from "./FacilityLimits.vue?vue&type=style&index=0&id=cd654e3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd654e3c",
  null
  
)

export default component.exports